import { createSlice } from "@reduxjs/toolkit";
import { initialValue } from "../pages/PartnerQuotaUIHelpers";

const initialPartnerQuotaState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  groupEntities: null,
  partnerQuotaForEdit: undefined,
  roleMaster: [],
  lastError: null,
  initialFormValue: {...initialValue}
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const partnerQuotaSlice = createSlice({
  name: "partnerQuota",
  initialState: initialPartnerQuotaState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getPartnerQuotaById
    partnerQuotaFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.partnerQuotaForEdit = action.payload.partnerQuotaForEdit;
    },
    // findPartnerQuota
    partnerQuotasFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    partnerQuotaGroupsFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.groupEntities = items;
      state.totalCount = total_items;
    },
    roleMasterFetched: (state, action) => {
      state.actionsLoading = false;
      state.roleMaster = action.payload.roleMaster;
      state.error = null;
    },
    setInitialFormValue: (state, action) => {
      state.initialFormValue = {...action.payload.formValues};
    },
    resetInitialFormValue: (state) => {
      state.initialFormValue = {...initialValue};
    },
    // Set to default state actionLoading & error
    partnerQuotaReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
  },
});
